import { ResponsibleHist } from "../../../general/src/ResponsibleHist";
import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutBillingUsers extends Layout {
    layoutResponsibleHist: ResponsibleHist;
    sourceBilling: DataSource;
    sourceOrders: DataSource;
    sourceResponsibleHist: DataSource;
    textboxAgentPayeeId: Textbox;
    textboxBillingUserId: Textbox;
    textboxEnteredUserId: Textbox;
    textboxOperationsUser: Textbox;
}
